import { isStringEmpty } from "@/common/validation-checkers";
import { useEffect, useRef } from "react";

interface IProps {
    value?: string;
    purpose: string;
    newValue: (val: string | undefined) => void;
    type?: string;
    isAutoFocusElement?: boolean;
}

const StringComponent: React.FC<IProps> = ({value, purpose, newValue, type, isAutoFocusElement}) => {
    const autoFocusElement = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (isAutoFocusElement) {
            if (autoFocusElement?.current) {
                autoFocusElement.current.focus();
            }
        }
    }, [autoFocusElement.current])


    return (
        <div className="mx-4 mt-1">
            <label className='py-1 block text-gray-200 text-md' htmlFor={purpose}>{purpose}</label>
            <input 
                ref={autoFocusElement}
                className="text-black px-2 py-1 block w-full"
                type={type ?? "text"}
                id={purpose}
                value={value || ""} 
                onChange={(event) => isStringEmpty(event.target.value) ? newValue(undefined) : newValue(event.target.value)} 
            />
        </div>
    )
}

export default StringComponent;